


export const SpecialOffer_START = 'SpecialOffer_START';
export const SpecialOffer_END = 'SpecialOffer_END';
export const SpecialOffer_ERROR = 'SpecialOffer_ERROR';
export const SpecialOffer_SUCCESS = 'SpecialOffer_SUCCESS';
export const SpecialOffer_FAIL = 'SpecialOffer_FAIL';
export const IsDataSubmitedSuccessfullySpecialPromos = 'IsDataSubmitedSuccessfullySpecialPromos'